import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'date',
})
export class ExtendDatePipe extends DatePipe implements PipeTransform {
    constructor() {
        super('en');
    }

    transform(value: Date | string | number, format?: string, timezone?: string, locale?: string): string | null;
    transform(value: null | undefined, format?: string, timezone?: string, locale?: string): null;
    transform(value: Date | string | number | null | undefined, format?: string, timezone?: string, locale?: string): string | null;

    transform(value: Date | string | number | null | undefined, format?: string, timezone?: string, locale?: string): string | null {
        let appLocale;
        if (localStorage.getItem('app_locale')) {
            appLocale = localStorage.getItem('app_locale');
        } else {
            appLocale = 'en';
        }
        return super.transform(value, format, timezone, appLocale);
    }
}
